import AuthService from '../services/auth-service'

const GA_ID = process.env.REACT_APP_GA_ID;

export const initGoogleAnalytics = (userId = null) => {
  if (!GA_ID) {
    console.warn("GA_ID is not defined");
    return;
  }

  if (window.gtagInitialized) return;

  // Load GA4 script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  script.onload = () => {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;

    gtag('js', new Date());

    if (userId) {
      gtag('config', GA_ID, {
        user_id: userId,
        send_page_view: false,
        debug_mode: false,
      });

      gtag('set', 'user_properties', {
        user_id: userId,
      });
    } else {
      gtag('config', GA_ID, {
        send_page_view: false,
        debug_mode: false,
      });
    }

    // Send page_view manually
    gtag('event', 'page_view', {
      ...(userId ? { user_id: userId } : {}),
    });

    // Track scroll once
    const onScroll = () => {
      const scrollPercentage = Math.round(
        ((window.scrollY + window.innerHeight) / document.body.scrollHeight) * 100
      );

      gtag('event', 'scroll_depth', {
        scroll_percentage: scrollPercentage,
        ...(userId ? { user_id: userId } : {}),
      });

      window.removeEventListener('scroll', onScroll);
    };

    window.addEventListener('scroll', onScroll, { once: true });

    window.gtagInitialized = true;
  };
};

// ✅ Call after login to update user_id context
export const updateUserId = (userId) => {
  if (typeof window.gtag === 'function' && userId) {
    window.gtag('config', GA_ID, {
      user_id: userId,
    });

    window.gtag('set', 'user_properties', {
      user_id: userId,
    });
  }
};

export const triggerGaEvents = (eventName, extraParams = {}) => {
  const gaId = AuthService.getGaId();
  const token = AuthService.getToken();
  const msToken = AuthService.getMSToken();
  const user_type = token ? 'Account_Service' : (msToken ? 'Microsoft' : 'Anonymous');
  if (eventName) {
    window.gtag?.('event', eventName, {
      user_type: user_type,
      user_id: gaId,
      ...extraParams,
    });
  }
}
